import React, { Fragment, useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import {
  Grid,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Divider,
} from '@material-ui/core';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import { ChevronRight as ChevronRightIcon } from '@material-ui/icons';
import { AppBar, Page, ScreenLoader, EmptyState } from 'components';
import { ru } from 'locale';
import { anketsStore, objectsStore, backNavigationStore } from 'stores';

const ObjectsScreen = observer(() => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const { objects, fetchState } = objectsStore;
  const { backUrl } = backNavigationStore;

  useEffect(
    () =>
      autorun(() => {
        objectsStore.getObjects(anketsStore.anketId);
      }),
    [],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const renderObjects = () => {
    return objects.length === 0 ? (
      <EmptyState title={ru.emptyList(ru.listOfObjects)} />
    ) : (
      <List component="nav" aria-label={ru.listOfObjects}>
        {objects.map((item, idx) => (
          <Fragment key={item.id}>
            <ListItem button component={Link} to={`${path}/${item.id}`}>
              <ListItemText primary={item.name} />
              <ListItemSecondaryAction>
                <ChevronRightIcon />
              </ListItemSecondaryAction>
            </ListItem>
            {idx !== objects.length - 1 && <Divider />}
          </Fragment>
        ))}
      </List>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <Grid item>
          <AppBar
            title={ru.kfAnalytics}
            onNavButtonClick={handleBackClick}
            backUrl={`${backUrl}#objects`}
            typeNavIcon="link"
          />
        </Grid>
        <Grid>
          {fetchState === 'pending' && <ScreenLoader />}
          {fetchState === 'fulfilled' && renderObjects()}
        </Grid>
      </Grid>
    </Page>
  );
});

export default ObjectsScreen;
